import React from "react";
import { CustomImageProps } from "./CustomImage.types";
import { ImageContainer } from "./CustomImage.style";

export default function CustomImage({
  desktop,
  tablet,
  mobile,
  alt,
  title,
  link,
  target,
  id,
  preferwebp,
  quality,
}: CustomImageProps) {

  const blankSpace = (src: string) => {
    return src.replace(/ /g, '%20');
  };

  function imageConfig(src?: string) {
    if (src) {
      const validExtensions = [".jpg", ".png"];
      const hasValidExtension = validExtensions.some((ext) =>
        src.endsWith(ext)
      );

      if (hasValidExtension) {
        return `${blankSpace(src)}${preferwebp ? `?${preferwebp}&` : "?"}quality=${quality}`;
      }
    }
    return blankSpace(src || "");
  }

  const Image = () => (
      <img
        className="cmp-image__image"
        src={
          mobile
            ? imageConfig(mobile)
            : tablet
            ? imageConfig(tablet)
            : imageConfig(desktop)
        }
        alt={alt}
        title={title}
      />
  );

  const Picture = () => {
    if (!!mobile || !!tablet) {
      return (
        <picture>
          <source media="(min-width: 1024px)" srcSet={imageConfig(desktop)} />
          <source
            media="(min-width: 768px) and (max-width: 1023px)"
            srcSet={tablet ? imageConfig(tablet) : imageConfig(desktop)}
          />
          <Image/>
        </picture>
      );
    }
  
    return (
      <Image/>
    );
  };

  return (
    (!!desktop || !!tablet || !!mobile) ? (<ImageContainer className="cmp-image" id={id}>
      {link ? (
        <a
          className="cmp-image__link"
          href={link}
          target={target}
          rel="noopener noreferrer"
        >
          <Picture />
        </a>
      ) : (
        <Picture />
      )}
    </ImageContainer>) : <></>
  );
};
